module.exports = {
    TRANSFER_INFORMATION: {
        TRANSFER_COUNTRY: 'ES',
        TRANSFER_TYPE: 'EMISION',
        RECIPIENT_INDICATOR: 'S',
        BENEFICIARY_BANK_NAME: 'S',
        BENEFICIARY_INDICATOR: 'S',
        PAYMENT_TYPE: 'C'
    }
};